/**
 * @file RouteLoadingFallback.tsx
 * @description Loading fallback component for lazy-loaded routes.
 * Provides a consistent loading state across the application when
 * route chunks are being fetched.
 */

import type React from 'react';
import Spinner from './Spinner';

const RouteLoadingFallback: React.FC = () => {
  return (
    <div className="h-full w-full bg-black text-gray-100 flex justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <Spinner />
        <p className="font-oswald text-white text-[20px] tracking-[1.2px]">
          LOADING...
        </p>
      </div>
    </div>
  );
};

export default RouteLoadingFallback;
